// S&A (Tankrevision,Boiler): mehrere Warenempf�nger und/oder mehrere Anlagen

// state
const state = {
    numberUnloadingPoints: null, //int 
    numberTanks: null, //int 
    deliveryPeriod: ''
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {    
    setNumberUnloadingPoints(state, newValue) {
        state.numberUnloadingPoints = newValue;
    },
    setNumberTanks(state, newValue) {
        state.numberTanks = newValue;
    },
    setDeliveryPeriod(state, newValue) {
        state.deliveryPeriod = newValue;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}